/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Signature Maker`)
};

const es_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre el Generador de Firmas`)
};

const de_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie den Signaturmaker`)
};

const nl_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open de Handtekeningmaker`)
};

const fr_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le Créateur de Signature`)
};

const it_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il Creatore di firme`)
};

const pt_br2_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir o Criador de Assinatura`)
};

const pt_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir o Criador de Assinaturas`)
};

const ja_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名メーカーを開く`)
};

const zh_home_seo_signature_cta = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开签名制作工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_signature_cta = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_signature_cta(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_signature_cta", locale)
	if (locale === "en") return en_home_seo_signature_cta(inputs)
	if (locale === "es") return es_home_seo_signature_cta(inputs)
	if (locale === "de") return de_home_seo_signature_cta(inputs)
	if (locale === "nl") return nl_home_seo_signature_cta(inputs)
	if (locale === "fr") return fr_home_seo_signature_cta(inputs)
	if (locale === "it") return it_home_seo_signature_cta(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_signature_cta(inputs)
	if (locale === "pt") return pt_home_seo_signature_cta(inputs)
	if (locale === "ja") return ja_home_seo_signature_cta(inputs)
	return zh_home_seo_signature_cta(inputs)
};